import { FC, useState } from 'react';
import { Navigate } from 'react-router-dom';
import * as Yup from 'yup';
import { useFormik } from 'formik';
import { shallow } from 'zustand/shallow';

import Button from '../../../components/bootstrap/Button';
import Spinner from '../../../components/bootstrap/Spinner';
import FormGroup from '../../../components/bootstrap/forms/FormGroup';
import Input from '../../../components/bootstrap/forms/Input';
import useDarkMode from '../../../hooks/useDarkMode';
import Page from '../../../layout/Page/Page';
import PageWrapper from '../../../layout/PageWrapper/PageWrapper';
import { useUserStore } from '../../../stores/useUserStore';
import { LOCAL_STORAGE_TOKEN_KEY } from '../../../common/constants';
import logos from '../../../assets/logo/logo-new.png';

const Login: FC = () => {
	const { login } = useUserStore((state) => ({ login: state.login }), shallow);
	const [isLoading, setIsLoading] = useState<boolean>(false);

	const formik = useFormik({
		initialValues: {
			username: '',
			password: '',
		},
		validationSchema: Yup.object({
			username: Yup.string().required('Campo obbligatorio'),
			password: Yup.string().required('Campo obbligatorio'),
		}),
		validateOnChange: false,
		onSubmit: async (values) => {
			setIsLoading(true);
			try {
				await login({ username: values.username, password: values.password });
			} catch (err: any) {
				formik.setFieldError('username', err.message);
			} finally {
				setIsLoading(false);
			}
		},
	});

	if (localStorage.getItem(LOCAL_STORAGE_TOKEN_KEY)) {
		return <Navigate to='/homepage' />;
	}

	return (
		<PageWrapper isProtected={false} title='Login' className='bg-white'>
			<Page className='p-0'>
				<div className='d-flex justify-content-center align-items-center'>
					{/* Contenitore del form */}
					<div className='w-100' style={{ maxWidth: '400px' }}>
						{/* Logo centrato sopra il form */}
						<div className='text-center mb-4'>
							<img src={logos} alt='Logo' className='img-fluid' />
						</div>

						{/* Intestazione sopra il form */}
						<div className='text-center mb-4'>
							<h2>Benvenuto, accedi</h2>
						</div>

						<form className='kt-form' onSubmit={formik.handleSubmit}>
							<FormGroup id='username' isFloating label='Username'>
								<Input
									autoComplete='username'
									type='text'
									value={formik.values.username}
									invalidFeedback={formik.errors.username}
									isValid={formik.isValid}
									onChange={formik.handleChange}
									onBlur={formik.handleBlur}
								/>
							</FormGroup>

							<FormGroup className='mt-3' id='password' isFloating label='Password'>
								<Input
									type='password'
									autoComplete='current-password'
									value={formik.values.password}
									invalidFeedback={formik.errors.password}
									isValid={formik.isValid}
									onChange={formik.handleChange}
									onBlur={formik.handleBlur}
								/>
							</FormGroup>

							<div className='d-flex justify-content-center align-items-center mt-4'>
								<Button
									color='primary'
									className='w-100 py-3'
									type='submit'
									isDisable={isLoading || !formik.values.username || !formik.values.password}>
									{isLoading && <Spinner isSmall inButton isGrow />}
									Accedi
								</Button>
							</div>
						</form>
					</div>
				</div>
			</Page>
		</PageWrapper>
	);
};

export default Login;
